import AxiosInstance from './axios/interceptor';

const controller = 'EventImage';

export const deleteEventImageById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
